import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router";

export default function SidebarWidget() {
	const { setToken } = useAuth();
	const navigate = useNavigate();

	const handleLogout = () => {
		setToken(null);
		navigate("/login", { replace: true });
	};
	return (
		<div
			className={`
        mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-5 text-center dark:bg-white/[0.03]`}>
			<h3 className='mb-2 font-semibold text-gray-900 dark:text-white'>
				Log out?
			</h3>
			<p className='mb-4 text-gray-500 text-theme-sm dark:text-gray-400'>
				You will need your username and password to login back.
			</p>
			<div
				className='cursor-pointer flex items-center justify-center p-3 font-medium text-white rounded-lg bg-brand-900 text-theme-sm hover:bg-brand-500'
				onClick={() => handleLogout()}>
				Sign Out
			</div>
		</div>
	);
}
